import { render, staticRenderFns } from "./PaySlipFilter.vue?vue&type=template&id=2ef9a5e9&scoped=true&"
import script from "./PaySlipFilter.vue?vue&type=script&lang=js&"
export * from "./PaySlipFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef9a5e9",
  null
  
)

export default component.exports